import React, { useEffect, useState } from 'react'
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import {  interactionWall } from '../../../../../actions/appsMoreAction';
import { TOAST_DISMISS, TOAST_ERROR, TOAST_LOADING, TOAST_SUCCESS } from '../../../../../utils';
import CheckBoxField from '../../Feeds/AddFeeds/Elements/CheckboxField';
import { FontAwesomeIcon } from '../../../../CommonComponents/AssetsHelper';

  export default function InteractionWall(props) {
    const { themeSetting, getThemeSetting, wallData } = props;
    const { interactive } = getThemeSetting;
    const [spinner, setspinner] = useState(false);

    // useEffect(() => {
    //   const reactionIntro = document.getElementById('reactions');
    //   if(reactionIntro){
    //     localStorage.setItem('new-reactions', true);
    //     setTimeout(() => reactionIntro.click(), 2000); 
    //   } 
    // }, [])

    const onSubmitData = () => {
      setspinner(true)
      TOAST_LOADING();
      interactionWall({interactive, wallId: wallData.wallId, ownerId: wallData.wallOwner}).then(() => {
        TOAST_DISMISS()
        TOAST_SUCCESS('Interaction wall update successfully.');
        removeTab();
        props.activeSetting(0);
        removeTab();
        setspinner(false);
      }).catch(() => {
        TOAST_DISMISS()
        TOAST_ERROR();
        setspinner(false)
      });
    }

  const applyChanges = (status) => {
    const { showDiscardPop } = props;
  if(status == 0){ removeTab(); }
    showDiscardPop(onSubmitData, "theme-setting", status);
  };

  const removeTab = () => {
    const newUrl = window.location.href.replace(/\?tab=reactions[\/]?/, '')
    window.history.replaceState({}, '', newUrl) 
}

//   const addSupportLinkFun = (supportLink) =>{
//     if(supportLink){
//         setTimeout(() => {
//             $('.lity-container')
//             .append($("<div class='lity_read_more w-100 justify-content-center pt-5'><a class='btn btn-primary' href='"+supportLink+"' target='_blank'>Read More</a></div>").hide().fadeIn(500));
//         }, 200);
//     }else{
//         return false
//     }
// }

    return (
      <div className={`col-lg-12 col-md-12 col-sm-12 col-xs-12 cardProperties darkLabel d-flex flex-column justify-content-between h-100`}>
        <div className="intraction-list">
          <div className="hashtagHighlighter_wrap hashcolor d-flex h-100 flex-column justify-content-between">
            <div className="pb-3">
              <label className="card-label font-weight-bolder text-dark"> Reactions </label>
              <div className="form-group">
            <div className="d-flex align-items-center justify-content-between">
              <div className="col-9">
                <span>
                  Show/hide
                  <OverlayTrigger overlay={<Tooltip>Increase engagement on your social wall by allowing users to like the content they see.</Tooltip>}>
                    <span className="ms-1">
                      <FontAwesomeIcon type={'solid'} icon={'circle-info'} iconClass={'text-gray-500'} />
                    </span>
                  </OverlayTrigger>
                </span>
              </div>
              <div className="col-3">
                <div className="toggleOnBut">
                  <span className="switch float-end">
                    <label>
                      <CheckBoxField isChecked={interactive} onChangeHandler={(e) => themeSetting({ interactive: Number(!interactive), interactiveStatus: Number(!interactive) ? true : false  }) } name={`hashtag_feed`} id={`hashtag_feed`} text={0} />
                    </label>
                  </span>
                </div>
              </div>
            </div>
          </div>
          </div>

          <div className="preview_sidebar_area p-0">
            <div className="layout-disc">
              <strong>Reactions</strong>
              <p>Best Practices:</p>
              <hr />
              <div className="layout-disc-icons">
                  <p>1. Share the Social Wall with your attendees and amplify your event engagement.</p>
                  <p>2. Encourage more participation by hosting contests and rewarding attendees who get the most reactions to their content.</p>
                  <p>3. Encourage your top event voices to share more content, garnering more reactions in return and ultimately boosting engagement.</p>
              </div>
              <div className='cta_box'>How to Add Reactions on Social Wall - <a href='https://socialwalls.com/support/how-to-add-reactions-feature-to-social-wall/' target="_blank" style={{color: 'blue'}}>Know Here</a></div>
            </div>
          </div>
        </div>

        {/* <a href={`${MediaBaseUrl}products/interactive_social_walls.mp4`} id='reactions' className="ms-2 d-flex pt-1 lity_lightbox d-none" data-lity onClick={()=>addSupportLinkFun('https://taggbox.com/support/how-to-add-reactions-feature-to-social-wall/')}></a> */}

        <div className="form-actions pb-3 mt-3">
          <div className="card-toolbar f-center">
            <Button onClick={() => applyChanges(0)} variant="secondary" className="w-50 me-2 position-relative" > <span className="position-relative">Back</span> </Button>
            <Button disabled={spinner ? true : false} onClick={() => applyChanges(1)} variant="dark" className={`w-50 me-1 ${ spinner ? `spinner spinner-white spinner-right disabled` : null }`} > Save </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
